module.exports = __webpack_public_path__ + "static/media/item-12.14d0aada.png";